import axios from 'axios';

import { PortfolioStatisticsFilter } from '../enums/portfolio-statistics-filter.enum';
import { PortfolioStatisticsDto } from '../interfaces/portfolio-statistics.dto';
import { PortfolioTimeSeriesDto } from '../interfaces/portfolio-time-series.dto';
import { PropertyPerformanceDto } from '../interfaces/property-performance.dto';

class PortfolioStatisticsService {
  async get(filter: PortfolioStatisticsFilter): Promise<PortfolioStatisticsDto> {
    const response = await axios.get<PortfolioStatisticsDto>('portfolio-statistics/owner', {
      params: {
        filter,
      },
    });

    return response.data;
  }

  async getTimeSeries(filter: PortfolioStatisticsFilter): Promise<PortfolioTimeSeriesDto> {
    const response = await axios.get<PortfolioTimeSeriesDto>('portfolio-statistics/owner/time-series', {
      params: {
        filter,
      },
    });

    return response.data;
  }

  async getColdUnits(filter: PortfolioStatisticsFilter): Promise<PropertyPerformanceDto> {
    const response = await axios.get<PropertyPerformanceDto>('portfolio-statistics/owner/cold-units', {
      params: {
        filter,
        limit: 20,
      },
    });

    return response.data;
  }

  async getHotUnits(filter: PortfolioStatisticsFilter): Promise<PropertyPerformanceDto> {
    const response = await axios.get<PropertyPerformanceDto>('portfolio-statistics/owner/hot-units', {
      params: {
        filter,
        limit: 20,
      },
    });

    return response.data;
  }
}

export default new PortfolioStatisticsService();
